import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./useAppStore";
import { fetchHomeDashboard } from "../store/slices/alliancesSlice";

export function useHomePage() {
  const dispatch = useAppDispatch();
  const stats = useAppSelector((s) => s.alliances.stats);
  const allianceCoverage = useAppSelector((s) => s.alliances.allianceCoverage);
  const loading = useAppSelector((s) => s.alliances.homeLoading);

  useEffect(() => {
    dispatch(fetchHomeDashboard());
  }, [dispatch]);

  return { stats, allianceCoverage, loading };
}
